// frontend/src/pages/ProjectSales.tsx
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useProjectFormStore } from "@/store/project-form-provider";
import { ProjectInputField } from "@/components/project-input-field";
import { ProjectSaveButton } from "@/components/project-save-button";
import { ProjectResetButton } from "@/components/project-reset-button";

export default function ProjectSales() {
  const { loading, error, formData, updateField, saveAll, resetAll, savingAll, getFieldType, getFieldOptions,
  } = useProjectFormStore();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateField(name, value);
  };

  const { t } = useTranslation();

  if (loading) return <div className="p-4 text-xs">{t("common.loading")}</div>;
  if (error || !formData) return <div className="p-4 text-elani text-xs">{t("common.error_loading_data")}</div>;
  
  return (
    <form className="max-w-md space-y-8 text-xs">
      <div className="space-y-2">
        <ProjectInputField label={t("project.sales.initial_tariff_type")} name="sales_type" value={formData.sales_type} type={getFieldType("sales_type")} onChange={handleChange} />
        <ProjectInputField label={t("project.sales.initial_tariff_duration") + " (" + t("project.sales.initial_tariff_duration_unit") + ")"} name="duration_initial_tariff" value={formData.duration_initial_tariff} type={getFieldType("duration_initial_tariff")} onChange={handleChange} />
        <ProjectInputField label={t("project.sales.initial_tariff") + " (" + t("project.sales.initial_tariff_unit") + ")"} name="initial_tariff" value={formData.initial_tariff} type={getFieldType("initial_tariff")} onChange={handleChange} />
        <ProjectInputField label={t("project.sales.initial_tariff_annual_price_increase")} name="annual_price_increase_for_initial_tariff" value={formData.annual_price_increase_for_initial_tariff} type={getFieldType("annual_price_increase_for_initial_tariff")} onChange={handleChange} />
      </div>

      <div className="space-y-2">
        <ProjectInputField label={t("project.sales.residual_tariff") + " (" + t("project.sales.residual_tariff_unit") + ")"} name="residual_power_price" value={formData.residual_power_price} type={getFieldType("residual_power_price")} onChange={handleChange} />
        <ProjectInputField label={t("project.sales.residual_tariff_annual_price_increase")} name="annual_price_increase_for_residual_term" value={formData.annual_price_increase_for_residual_term} type={getFieldType("annual_price_increase_for_residual_term")} onChange={handleChange} />
      </div>

      <div className="pt-3 flex gap-2">
        <ProjectSaveButton onSave={saveAll} saving={savingAll} />
        <ProjectResetButton onReset={resetAll} saving={savingAll} />
      </div>
    </form>
  );
}